export default "__VITE_ASSET__2DdqxF1Q__"